import React from "react";
import style from "./index.module.scss";
import { Button, message } from "antd";
import usePromiseCallback from "utils/usePromiseCallback";
import { endVote, publishVotePaper } from "service/vote";
import { errorMessage } from "service/service";

interface LinksProps {
    voteId: number;
    isStart: boolean;
    onShowVote: () => void;
    onEnd?: () => void;
}

export default function Links({
    voteId,
    isStart,
    onShowVote,
    onEnd
}: LinksProps) {
    const handleStart = usePromiseCallback(async function () {
        try {
            await publishVotePaper(voteId);
            onShowVote();
        } catch (e) {
            message.error(errorMessage(e));
        }
    });

    const handleEnd = usePromiseCallback(async function () {
        try {
            await endVote(voteId);
            onShowVote();
            onEnd?.();
        } catch (e) {
            message.error(errorMessage(e));
        }
    });

    return (
        <div className={style.root}>
            {!isStart && (
                <Button type="link" onClick={handleStart}>
                    开始投票
                </Button>
            )}
            {isStart && (
                <Button type="link" onClick={() => onShowVote()}>
                    进入活动
                </Button>
            )}
            {isStart && (
                <Button type="link" onClick={handleEnd}>
                    结束投票
                </Button>
            )}
        </div>
    );
}
